export const DEFAULT_CATEGORICAL_FEEDBACK = {
  type: 'categorical' as const,
  categoricalConfig: {
    categories: [
      {
        category: 'category',
        description: '',
      },
    ],
  },
};

export const DEFAULT_CONTINUOUS_FEEDBACK = {
  type: 'continuous' as const,
  continuousConfig: {
    min: 1,
    max: 10,
    minDescription: '',
    maxDescription: '',
  },
};

export const DEFAULT_BOOLEAN_FEEDBACK = {
  type: 'boolean' as const,
};

export const FEEDBACK_TYPES = [
  {
    type: 'boolean',
    label: 'Boolean',
  },
  {
    type: 'categorical',
    label: 'Categorical',
  },
  {
    type: 'continuous',
    label: 'Score',
  },
];

export const PROMPT_EXCLUDED_VARIABLES = [
  'few_shot_examples',
  'examples_few_shot',
  'few_shot_explanation',
  'all_messages',
];
export const FEW_SHOT_EXCLUDED_VARIABLES = ['few_shot_explanation', 'score'];

export const SESSION_RULE_CRUD_PANE_WIDTH = 500;
export const SESSION_EVAL_CRUD_PANE_WIDTH = 700;
export const SESSION_EVAL_EXPANDED_CRUD_PANE_WIDTH = 1000;

export const THREAD_AVAILABLE_PATHS = ['All messages'];
